import React from 'react';
import styled from 'styled-components';

const Caret = ({className, fill, height, width}) => (
    <svg version="1.1"
        style={{
            fill,
            width,
            height
        }}
        className={className}
        preserveAspectRatio="none"
        viewBox="0 0 24 24">
        <g>
            <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" style={{ fill: '#fff'}} />
        </g>
    </svg>
);

Caret.defaultProps = {
    width: '32px',
    height: '32px',
    fill: '#fff'
};

export default styled(Caret)`
    fill: ${props => props.fill || '#fff'};
    width: ${props => props.width};
    height: ${props => props.height};
`;




// WEBPACK FOOTER //
// ./src/components/Caret.js